import Image from 'next/image';
import appStoreBadge from '../../images/app-store.svg';
import playStoreBadge from '../../images/play-store.svg';

const APP_STORE_URL =
  'https://apps.apple.com/app/apple-store/id6670431055?pt=122664205&ct=travelfeed-guide&mt=8';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.curlycorn.menutranslator&referrer=utm_source%3Dtravelfeed%26utm_medium%3Dguide';

// Menu Translator as a quiet margin note beside the dish menu — one
// sentence and the store badges, deliberately subordinate to the actual
// content (the dish card is the star of this spread).
export default function GuideAppStrip() {
  return (
    <aside className="tw-max-w-md tw-rounded-2xl tw-border-[1.5px] tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-px-6 tw-py-5">
      <p className="tw-m-0 tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-[#8A958F]">
        From the TravelFeed team
      </p>
      <p className="tw-mb-0 tw-mt-2 tw-text-[15px] tw-leading-relaxed tw-text-[#33403B] dark:tw-text-[#C7D2CC]">
        Menus looking like riddles? Snap a photo with Menu Translator and
        know what every dish actually is.
      </p>
      <div className="tw-mt-4 tw-flex tw-flex-wrap tw-items-center tw-gap-3">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-transition-transform tw-duration-200 hover:-tw-translate-y-0.5"
        >
          <Image
            src={appStoreBadge}
            alt="Download on the App Store"
            className="tw-h-9 tw-w-auto"
            unoptimized
          />
        </a>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="tw-transition-transform tw-duration-200 hover:-tw-translate-y-0.5"
        >
          <Image
            src={playStoreBadge}
            alt="Get it on Google Play"
            className="tw-h-9 tw-w-auto"
            unoptimized
          />
        </a>
      </div>
    </aside>
  );
}
